import { v2Request } from "helpers/request";
import { BlockFormData } from "components/delegatedUser/delegateRepCard/DelegateRepBlockInputs";

export const getDelegateCalendarAppointments = ({
  from,
  to,
}: {
  from: string;
  to: string;
}) => {
  return v2Request(`/appointments/delegate-calendar/${from}/${to}`);
};

export const getDelegateReps = ({
  page = 1,
  limit = 20,
  search = "",
  sortBy = "FirstName",
  sortOrder = "asc",
  officeId,
  showPending = true,
  showApproved = true,
  showDenied = true,
  showBlocked = true,
}: {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: string;
  sortOrder?: string;
  officeId?: number;
  showPending?: boolean;
  showApproved?: boolean;
  showDenied?: boolean;
  showBlocked?: boolean;
}) => {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    search,
    sortBy,
    sortOrder,
  });

  if (officeId) {
    params.append("officeId", officeId.toString());
    params.append("showPending", showPending.toString());
    params.append("showApproved", showApproved.toString());
    params.append("showDenied", showDenied.toString());
    params.append("showBlocked", showBlocked.toString());
  }

  return v2Request(`/users/delegate/reps-paginated?${params.toString()}`);
};

export const getDelegateRepComplianceFiles = (repId: number) => {
  return v2Request(`/files/user-delegate/${repId}`);
};

export const sendDelegateEmailToReps = (formData: FormData) => {
  return v2Request("/users/delegate-email-reps", {
    method: "POST",
    body: formData,
    headers: {}, // Let browser set multipart/form-data boundary
  });
};

interface ApprovalUpdate {
  officeId: number;
  repId: number;
  approved: boolean | null;
}

export const upsertDelegateApprovals = (approvals: ApprovalUpdate[]) => {
  return v2Request("/offices/delegate-preapprovals", {
    method: "PUT",
    body: JSON.stringify({ approvals }),
  });
};

export const bulkBlockRepDelegate = (
  repId: number,
  officeIds: number[],
  blockData: BlockFormData,
) => {
  return v2Request("/offices/bulk-block-delegate/rep", {
    method: "POST",
    body: JSON.stringify({
      repId,
      officeIds,
      blockDate: blockData.blockDate,
      blockReason: blockData.blockReason,
      indefiniteBlockCheck: blockData.indefiniteBlockCheck,
      comments: blockData.comments,
    }),
  });
};

export const bulkUnblockRepDelegate = (repId: number, officeIds: number[]) => {
  return v2Request("/offices/delegate-blocks/rep", {
    method: "DELETE",
    body: JSON.stringify({
      repId,
      officeIds,
    }),
  });
};

export const getDelegateRepAppointments = ({
  repId,
  officeIdFilter,
  from,
  to,
  confirmation,
  type,
  sortBy = "date",
  sortOrder = "desc",
  page = 1,
  pageSize = 20,
  refresh = false,
}: {
  repId: number;
  officeIdFilter?: number;
  from?: string;
  to?: string;
  confirmation?: boolean;
  type?: string;
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  pageSize?: number;
  refresh?: boolean;
}) => {
  return v2Request("/appointments/rep-appointments-delegate", {
    method: "POST",
    body: JSON.stringify({
      repId,
      officeIdFilter,
      from,
      to,
      confirmation,
      type,
      sortBy,
      sortOrder,
      page,
      pageSize,
      refresh,
    }),
  });
};

export const getDelegateActivityLogs = ({
  page = 1,
  limit = 20,
  officeId,
  category,
  sortOrder = "desc",
}: {
  page?: number;
  limit?: number;
  officeId?: number;
  category?: string;
  sortOrder?: string;
}) => {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    sortOrder,
  });

  if (officeId) {
    params.append("officeId", officeId.toString());
  }

  if (category) {
    params.append("category", category);
  }

  return v2Request(`/offices/all-activity?${params.toString()}`);
};
